/*
    Add here your own custom javascript
*/ 
jQuery(document).ready(function(){ 
jQuery("#shopify-section-template--17898423779370__cards_with_image_7VTmfC").hide();
jQuery("#shopify-section-template--17898423779370__cards_with_image_QEgaa4").hide();

// Second section के बाद Load More button add कर दो
jQuery("#shopify-section-template--17898423779370__cards_with_image_qLDQBi")
.after('<div class="text-center mt-4"><button class="btn btn-primary load-more-sections">View More Artists</button></div>');

// Load More click पर बाकी sections दिखाओ
jQuery(document).on("click", ".load-more-sections", function(){
jQuery("#shopify-section-template--17898423779370__cards_with_image_7VTmfC").slideDown(600);
jQuery("#shopify-section-template--17898423779370__cards_with_image_QEgaa4").slideDown(600);
jQuery(this).remove();
});
}); 